import { initializeApp } from 'firebase/app';
import { getMessaging, onMessage, getToken } from "firebase/messaging";

initializeApp({
  apiKey: "AIzaSyCb5uG6kgZS7ZWGKyWwDVXg6f-8vKd-NiU",
  authDomain: "pickmeup-b41fd.firebaseapp.com",
  projectId: "pickmeup-b41fd",
  storageBucket: "pickmeup-b41fd.firebasestorage.app",
  messagingSenderId: "229431657051",
  appId: "1:229431657051:web:dd0871823071eaa5d2b57e"
});


export const getFcmToken = async () => {
  try {
    const messaging = getMessaging();
    const fcmToken = await getToken(messaging, { vapidKey: process.env.REACT_APP_VAPID_PUBLIC_KEY });
    return fcmToken;
  } catch (err) {
    console.warn('Error getting FCM token:', err);
    return null;
  }
}

export const initMessageHandlers = () => {
  try {
    const messaging = getMessaging();
    onMessage(messaging, (payload) => {
      console.log('Message received. ', payload);
      // ...
    });
  } catch (err) {
    console.warn('Error initializing message handlers:', err);
  }
}

